import type { TranslationKeys } from '../types';

export const kkKZ: TranslationKeys = {
  // Home page
  'home.title': 'Жасанды интеллектке негізделген кездесу платформасы',
  'home.createMeeting': 'Жаңа кездесу құру',
  'home.creating': 'Құрылуда...',
  'home.or': 'немесе',
  'home.joinPlaceholder': 'Кодты немесе сілтемені енгізіңіз',
  'home.join': 'Қосылу',
  'home.errorDefault': 'Қате орын алды',
  'home.meetingCreateFailed': 'Кездесу құру мүмкін болмады',
  'home.poweredBy': 'Қолдаушы',

  // Join page
  'join.unableToJoin': 'Кездесуге қосылу мүмкін емес',
  'join.tryAgain': 'Қайталап көріңіз',
  'join.creatingSession': 'Жаңа сессия құрылуда...',
  'join.joiningMeeting': 'Кездесуге қосылуда...',
  'join.loadingInfo': 'Кездесу туралы ақпарат жүктелуде...',
  'join.failedToJoin': 'Кездесуге қосылу мүмкін болмады',
  'join.unexpectedError': 'Күтпеген қате орын алды',
  'join.encounteredError': 'Күтпеген қате орын алды: {message}',
  'join.meetingDetails': 'Кездесу мәліметтері',
  'join.ok': 'Жарайды',
  'join.cameraUnavailable': 'Камера қолжетімсіз, оны басқа қолданба пайдалануы мүмкін.',
  'join.micUnavailable': 'Микрофон қолжетімсіз, оны басқа қолданба пайдалануы мүмкін.',
  'join.mediaDeviceError': 'Медиа құрылғы қатесі: {message}',

  // PreJoin
  'prejoin.joinLabel': 'Бөлмеге қосылу',
  'prejoin.userLabel': 'Пайдаланушы аты',
  'prejoin.micLabel': 'Микрофон',
  'prejoin.camLabel': 'Камера',

  // Settings menu
  'settings.mediaDevices': 'Медиа құрылғылар',
  'settings.recording': 'Жазба',
  'settings.camera': 'Камера',
  'settings.microphone': 'Микрофон',
  'settings.speakerHeadphones': 'Динамик және құлақаспап',
  'settings.audioOutput': 'Дыбыс шығысы',
  'settings.recordMeeting': 'Кездесуді жазу',
  'settings.meetingRecording': 'Кездесу жазылып жатыр',
  'settings.noActiveRecordings': 'Бұл кездесу үшін белсенді жазба жоқ',
  'settings.startRecording': 'Жазуды бастау',
  'settings.stopRecording': 'Жазуды тоқтату',
  'settings.close': 'Жабу',

  // Control bar
  'controls.microphone': 'Микрофон',
  'controls.camera': 'Камера',
  'controls.leave': 'Шығу',
  'controls.chat': 'Чат',
  'controls.shareScreen': 'Экранды бөлісу',
  'controls.stopScreenShare': 'Бөлісуді тоқтату',
  'controls.settings': 'Параметрлер',
  'controls.pause': 'Кездесуді кідірту',
  'controls.allowAudio': 'Дыбысты қосу',

  // Chat panel
  'chat.title': 'Хабарламалар',
  'chat.placeholder': 'Хабарлама жазыңыз...',
  'chat.send': 'Жіберу',
  'chat.close': 'Чатты жабу',

  // Connection state toast
  'connection.connecting': 'Байланыс орнатылуда',
  'connection.reconnecting': 'Қайта қосылуда',
  'connection.disconnected': 'Байланыс үзілді',

  // Participant tile
  'participant.screenShareSuffix': ' – экраны',

  // Question panel
  'question.speakAnswer': 'Өтінеміз, ауызша жауап беріңіз',

  // Pause overlay
  'pause.title': 'Кездесу кідіртілді',
  'pause.description': 'Дайын болғанда тоқтаған жеріңізден жалғастыра аласыз.',
  'pause.resume': 'Кездесуді жалғастыру',
  'pause.failed': 'Кездесуді кідірту мүмкін болмады. Қайталап көріңіз.',
  'pause.resumeFailed': 'Кездесуді жалғастыру мүмкін болмады. Қайталап көріңіз.',
  'pause.pausing': 'Кездесу кідіртілуде...',
  'pause.resuming': 'Кездесу жалғасуда...',
  'pause.waitingAgent': '{name} күтілуде...',
  'pause.agentFallback': 'көмекші',

  // Common
  'common.processing': 'Өңделуде...',
  'common.close': 'Жабу',
  'common.download': 'Жүктеп алу',
  'common.image': 'Сурет',
  'common.previousTab': 'Алдыңғы қойынды',
  'common.nextTab': 'Келесі қойынды',

  // Content panel
  'content.openPdf': 'PDF ашу',
  'content.pdfHint': 'PDF жаңа қойындыда ашылады',
  'content.loadingPdf': 'PDF жүктелуде...',
  'content.loadingImage': 'Сурет жүктелуде...',
  'content.imageLoadFailed': 'Сурет жүктелмеді. Жүктеу түймесін пайдаланыңыз.',
  'content.clickDownload': 'Ашу үшін жүктеу түймесін басыңыз',
  'content.document': 'Құжат',
  'content.text': 'Мәтін',
  'content.tabQuestion': 'СҰРАҚ',
  'content.tabText': 'МӘТІН',
  'content.tabFile': 'ФАЙЛ',
  'content.badgeImage': 'СУРЕТ',
  'content.badgeFile': 'ФАЙЛ',

  // Presentation panel
  'presentation.loading': 'Презентация жүктелуде…',
  'presentation.loadingDetail': 'markdown: {count} таңба',
  'presentation.initFailed': 'Презентация іске қосылмады',

  // Mermaid diagram
  'diagram.loading': 'Диаграмма жүктелуде...',
  'diagram.syntaxError': 'Диаграмма синтаксисінде қате',
  'diagram.renderFailed': 'Диаграмманы құру мүмкін болмады',

  // Public slide preview page
  'preview.apiUrlMissing': 'API мекенжайы бапталмаған',
  'preview.loadFailed': 'Презентация жүктелмеді',
  'preview.loading': 'Жүктелуде…',

  // Settings menu
  'settings.backgroundEffects': 'Фон эффектілері',
  'settings.backgroundNone': 'Жоқ',
  'settings.backgroundBlur': 'Бұлыңғырлау',
  'settings.backgroundDesk': 'Жұмыс үстелі',
  'settings.backgroundNature': 'Табиғат',
  'settings.enableNoiseCancellation': 'Кеңейтілген шуды басуды қосу',
  'settings.disableNoiseCancellation': 'Кеңейтілген шуды басуды өшіру',
  'settings.recordingNoEndpoint': 'Жазба мекенжайы көрсетілмеген',
  'settings.recordingEncryptedUnsupported':
    'Шифрланған кездесулерді жазу әзірге қолдау таппайды',
  'settings.recordingInProgress': 'Бұл кездесу жазылып жатыр',

  // Sent to the AI agent
  'agent.questionDismissed':
    '[Пайдаланушы сұрақ терезесін жауап бермей жапты, әңгімені табиғи түрде жалғастыр]',
};
